<div class="address-details-container">
  <p>{{title}}</p>
  <form [formGroup]="addressForm" (blur)="onChanges()">
    <div class="form-group">
      <label>{{ "modeso_address_address-details_company" | injectedText | async }}
        <span class="optional">{{ "modeso_address_address-details_optional" | injectedText | async }}</span>
      </label>
      <div class="input-wrapper">
        <input id="company" class="form-control" type="text" minlength="1" maxlength="40" formControlName="company" [ngClass]="{'invalid-input': fieldErrorFlags['company']}"
          value="{{(address|async)?.company}}" (focusout)="checkForFieldError(company, 'company'); emitAlertMsg()">
      </div>
      <span class="required" *ngIf="fieldErrorFlags['company']">
        {{ "modeso_address_address-details_company-required" | injectedText | async }}
      </span>
    </div>
    <!-- First Name -->
    <div class="form-group">
      <label>{{ "modeso_address_address-details_first-name" | injectedText | async }}</label>
      <div class="input-wrapper">
        <input id="firstName" class="form-control" minlength="1" maxlength="40" [ngClass]="{'invalid-input': fieldErrorFlags['firstName']}" type="text" formControlName="firstName"
          value="{{(address|async)?.firstName}}" required (focusout)="checkForFieldError(firstName, 'firstName'); emitAlertMsg()">
      </div>
      <span class="required" *ngIf="fieldErrorFlags['firstName']">
        {{ "modeso_address_address-details_first-name-required" | injectedText | async }}
      </span>
    </div>
    <!-- Last Name -->
    <div class="form-group">
      <label>{{ "modeso_address_address-details_last-name" | injectedText | async }}</label>
      <div class="input-wrapper">
        <input id="lastName" class="form-control" minlength="1" maxlength="80" [ngClass]="{'invalid-input': fieldErrorFlags['lastName']}" type="text" formControlName="lastName"
          value="{{(address|async)?.lastName}}" required (focusout)="checkForFieldError(lastName, 'lastName'); emitAlertMsg()">
      </div>
      <span class="required" *ngIf="fieldErrorFlags['lastName']">
        {{ "modeso_address_address-details_last-name-required" | injectedText | async }}
      </span>
    </div>
    <!-- Street -->
    <div class="form-row">
      <div class="form-group col-lg-10">
        <label>{{ "modeso_address_address-details_street" | injectedText | async }}</label>
        <input id="street" class="form-control" minlength="1" maxlength="250" [ngClass]="{'invalid-input': fieldErrorFlags['street']}" type="text" formControlName="street" value="{{(address|async)?.street}}"
         (focusout)="checkForFieldError(street, 'street'); emitAlertMsg()">
        <span class="required" *ngIf="fieldErrorFlags['street']">
          {{ "modeso_address_address-details_street-required" | injectedText | async }}
        </span>
      </div>
      <!-- Street Number-->
      <div class="form-group col-lg-2">
        <label>{{ "modeso_address_address-details_street-number" | injectedText | async }}</label>
        <input id="streetNumber" class="form-control" maxlength="4" [ngClass]="{'invalid-input': fieldErrorFlags['streetNumber']}" type="text" formControlName="streetNumber"
          value="{{(address|async)?.streetNumber}}" (focusout)="checkForFieldError(streetNumber, 'streetNumber'); emitAlertMsg()">
        <span class="required" *ngIf="fieldErrorFlags['streetNumber']">
          {{ "modeso_address_address-details_street-number-required" | injectedText | async }}
        </span>
      </div>
    </div>
    <!-- Address Supplement -->
    <div class="form-group">
      <label>{{ "modeso_address_address-details_address-supplement" | injectedText | async }}
        <span class="optional">{{ "modeso_address_address-details_optional" | injectedText | async }}</span>
      </label>
      <div class="input-wrapper">
        <input id="addressSupplement" minlength="1" maxlength="250" class="form-control" type="text" formControlName="addressSupplement" [ngClass]="{'invalid-input': fieldErrorFlags['addressSupplement']}"
          value="{{(address|async)?.addressSupplement}}"  (focusout)="checkForFieldError(addressSupplement, 'addressSupplement'); emitAlertMsg()">
      </div>
      <span class="required" *ngIf="fieldErrorFlags['addressSupplement']">
        {{ "modeso_address_address-details_address-supplement-required" | injectedText | async }}
      </span>
    </div>
    <!-- Zip Code -->
    <div class="form-row">
      <div class="form-group col-lg-2">
        <label>{{ "modeso_address_address-details_zip-code" | injectedText | async }}</label>
        <input id="zipCode" class="form-control" [ngClass]="{'invalid-input': fieldErrorFlags['zipCode']}" type="text" formControlName="zipCode" minlength="4" maxlength="4"
          value="{{(address|async)?.zipCode}}" (focusout)="checkForFieldError(zipCode, 'zipCode'); emitAlertMsg()">
        <span class="required" *ngIf="fieldErrorFlags['zipCode']">
          {{ "modeso_address_address-details_zip-code-required" | injectedText | async }}
        </span>
      </div>
      <!-- city -->
      <div class="form-group col-lg-10">
        <label>{{ "modeso_address_address-details_city" | injectedText | async }}</label>
        <input id="city" class="form-control" minlength="2" maxlength="40" [ngClass]="{'invalid-input': fieldErrorFlags['city']}" type="text" formControlName="city" value="{{(address|async)?.city}}"
         (focusout)="checkForFieldError(city, 'city'); emitAlertMsg()">
        <span class="required" *ngIf="fieldErrorFlags['city']">
          {{ "modeso_address_address-details_city-required" | injectedText | async }}
        </span>
      </div>
    </div>
    <!-- Country -->
    <div class="form-group">
      <label>{{ "modeso_address_address-details_country" | injectedText | async }}</label>
      <div class="input-wrapper">
        <select class="classic col-12" id="country" formControlName="country">
          <option *ngFor="let country of countries" [value]="country.code">{{ country.name[getCurrentLanguage()] }}</option>
        </select>
      </div>
    </div>
    <!-- email -->
    <div class="form-group">
      <label>{{ "modeso_address_address-details_email" | injectedText | async }}</label>
      <div class="input-wrapper">
        <input id="email" class="form-control" type="email" minlength="5" maxlength="80" [ngClass]="{'invalid-input': fieldErrorFlags['email']}" formControlName="email" value="{{(address|async)?.email}}"
          required (focusout)="checkForFieldError(email, 'email'); emitAlertMsg()">
      </div>
      <span class="required" *ngIf="fieldErrorFlags['email']">
        {{ "modeso_address_address-details_email-required" | injectedText | async }}
      </span>
    </div>
  </form>
</div>
